module.exports = __webpack_public_path__ + "static/media/11.a4aacb0b.png";